export const TRACK_VIEW_MODE = {
  WEEK: "week",
  MONTH: "month",
  YEAR: "year",
};

export const TRACK_VIEW_MODES = [
  TRACK_VIEW_MODE.WEEK,
  TRACK_VIEW_MODE.MONTH,
  TRACK_VIEW_MODE.YEAR,
];

